module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGNISA36TwlmGDVg1IBRA4aLAQAOlBYfqpnNOQAAAABJRU5ErkJggg=="